import React from 'react';
import IconName from "../../svgLogo/SvgLogo";

const MenuScrollSpy = () => {
    return (
        <div className="menu-scroll-spy">
            <div className="navbar-menu-scroll">
                <div className="product-name-fixed d-none d-lg-block">
                    <div className="container">
                        <h2 className="text-product-fixed">Xiaomi Redmi Note 9 Pro Global Dual SIM 64GB- 6GB RAM</h2>
                    </div>
                </div>
                <nav id="nav-bar-single-page" className="navbar navbar-light navbar-menu-scroll-responsive">
                    <div className="container">
                        <ul className="nav nav-pills">
                            <li className="nav-item">
                                <a className="nav-link scroll-menu-smooth" data-scroll="product-scroll" href="#product-scroll"><IconName name="products"
                                                                                                className="icon"/><span className="text">محصول</span></a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link scroll-menu-smooth" data-scroll="sellers-scroll" href="#sellers-scroll"><IconName name="vendor"
                                                                                         className="icon"/> <span className="text">فروشندگان</span></a>
                                <span className="description-menu d-inline-block d-lg-none">۷ فروشنده</span>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link scroll-menu-smooth" data-scroll="study-scroll" href="#study-scroll"><IconName name="receipt_long"
                                                                                        className="icon"/> <span className="text">نقد و
                                    بررسی</span></a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link scroll-menu-smooth" data-scroll="technical-specifications-scroll" href="#technical-specifications-scroll"><IconName
                                    name="list_alt_scroll" className="icon"/> <span className="text">مشخصات فنی</span></a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link scroll-menu-smooth" data-scroll="bundle-scroll" href="#bundle-scroll"><IconName name="library_add"
                                                                                        className="icon"/> <span className="text">باندل</span> </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link scroll-menu-smooth" data-scroll="category-scroll" href="#category-scroll"><IconName name="category"
                                                                                          className="icon"/> <span className="text">مقایسه</span> </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link scroll-menu-smooth" data-scroll="timeline-scroll" href="#timeline-scroll"><IconName name="timeline"
                                                                                          className="icon"/><span className="text"> نمودار قیمت</span>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link scroll-menu-smooth" data-scroll="comments-scroll" href="#comments-scroll"><IconName name="comment"
                                                                                         className="icon"/><span className="text">نظرات
                                    کاربران </span></a>
                                <span className="description-menu d-inline-block d-lg-none">۷۱۱۲ دیدگاه</span>
                            </li>
                        </ul>
                    </div>
                </nav>
                <div className="nav-menu-scroll-responsive d-block d-lg-none ">
                    <div className="container">
                        <div className="d-flex justify-content-between align-items-center">
                            <div className="name-product">
                                <h2>Xiaomi Redmi Note 9</h2>
                            </div>
                            <div id="toggle-responsive-scroll-menu" className="click-toggle-menu">
                                <span><span id="text-page-position-responsive"></span> <IconName name="expand_more" className="icon"/></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MenuScrollSpy;
